/**
 * Asynchronously loads the component for DocumentPage
 */

import * as React from 'react';
import { lazyLoad } from 'utils/loadable';
import { LoadingIndicator } from 'app/components/LoadingIndicator';

export const OutResponsePage = lazyLoad(
  () => import('./OutResponsePrefiller'),
  module => module.Prefiller,
  {
    fallback: <LoadingIndicator />,
  },
);
